import Vue from 'vue';

import vuetify from './plugins/vuetify';

import App from "./layouts/app";
import router from "./router";
import store from "./store";
import VueFlashMessage from 'vue-flash-message';
import axios, {obterTokenAzure} from './plugins/axios';
import financeiro from './plugins/FinanceiroInterceptor';
import tradutor from "./plugins/TradutorInterceptor";
import moment from "moment";

import VuetifyMoney from "vuetify-money";
import VCurrencyField from 'v-currency-field'
import confirmDialogMixin from './mixins/confirmDialog'
import PreventDoubleClick from './plugins/preventDoubleClick'

Vue.use(PreventDoubleClick);

Vue.use(VCurrencyField, {
    locale: 'pt-BR',
})

Vue.use(VuetifyMoney);

// Mixin global para $confirmar() em todos os componentes
Vue.mixin(confirmDialogMixin);

Vue.use(VueFlashMessage, {
    messageOptions: {
        timeout: 3000,
    }
});

import Notifications from 'vue-notification'

Vue.use(Notifications)

Vue.use(require('vue-shortkey'))

import('./css/app.scss');
import('./css/metions.css');

Vue.filter('formataDecimal', function (value) {
        if (!value) return '';
        var formatter = new Intl.NumberFormat('pt-BR', {
            currency: 'BRL'
        });
        return formatter.format(value);
    }
);

Vue.filter('toCurrency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    });
    return formatter.format(value);
});

import {VueMaskDirective} from "v-mask";
import {isAdmin} from "./enums/PerfilPermissionamentoEnum";

Vue.directive("mask", VueMaskDirective);

Vue.filter('toDecimal', function (value, decimal = 2) {

    var formatter = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: decimal,
    });

    return formatter.format(value || 0);
});


Vue.filter('abertoFechado', function (value) {
    if (value) {
        return 'Aberto';
    }
    return 'Fechado';
});

Vue.filter('datamesanoporextenso', function (value) {
    if (value) {
        return moment(value).format('DD/MM/YYYY');
    }
    return '';

});

Vue.filter('formataData', function (value) {
    if (value && moment(value).isValid()) {
        return moment(value).format('DD/MM/YYYY');
    }
    return '';
});

Vue.filter('formataDataHora', function (value) {
    if (value && moment(value).isValid()) {
        return moment(value)
            .locale('pt-br')
            .format('DD/MM/YYYY HH:mm:ss');
    }
    return '';
});

Vue.filter('formataDataMesAnoPortugues', function (value) {
    if (value && moment(value).isValid()) {
        moment.locale('pt-br')
        var data = moment(value).format('MMM/YYYY');
        return data.toUpperCase();
    }

    return '';
});


Vue.filter('creditoDebito', function (value) {
    if (value == 'C') {
        return 'Crédito';
    }
    return 'Débito';
});

Vue.filter('formataHora', function (value) {
    if (value && moment(value).isValid()) {
        return moment(value).format('HH:mm');
    }
    return '';
});

Vue.filter('formataDataHora', function (value) {
    if (value && moment(value).isValid()) {
        return moment(value).format('DD/MM/YYYY HH:mm:ss');
    }
    return '';
});

Vue.filter('formataDataMesAno', function (value) {
    if (value && moment(value).isValid()) {
        return moment(value).format('MM/YYYY');
    }
    return '';
});

Vue.filter('simNao', function (value) {
    if (value) {
        return 'Sim';
    }
    return 'Não';
});


Vue.config.productionTip = false

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.deveEstarAutenticado)) {
        try {
            if (localStorage.getItem('apiToken')) {
                await verificaPerfilId();
            } else {
                await obterTokenAxios();
            }

            if (to.matched.some(record => record.meta.apenasAutorizados) && !isEmailAutorizado()) {
                return router.push({ name: 'error', query: { error: 403 } });
            }

            next();
        } catch (error) {
            router.push({ name: 'error', query: { error: 403 } });
        }
    } else {
        next();
    }

});

function isEmailAutorizado() {
    const account = localStorage.getItem('account');
    if (!account) return false;
    const { userName } = JSON.parse(account);
    const autorizados = process.env.AUTHORIZED_EMAILS.replace(/"/g, '').split(',');
    return autorizados.includes(userName);
}

async function verificaPerfilId() {
    try {
        store.dispatch('permissoes/getPermissoes').then((response) => {
            const permissoes = response.data.data.usuario;
            const perfilId = permissoes.perfil_id;

            if(!isAdmin(perfilId)) {
                throw new Error('Perfil inválido');
            }
        }).catch((error) => {
            return router.push({name: 'error', query: {error: 403}}).then(() => {router.go()});
        });
    } catch (error) {
        return router.push({name: 'error', query: {error: 403}}).then(() => {router.go()});
    }

}

async function obterTokenAxios() {
    try {
        await obterTokenAzure().then((response) => {
            return verificaPerfilId();
        });

    } catch (error) {
        console.log(error);
        throw error;
    }
}

new Vue({
    store,
    router,
    axios,
    financeiro,
    tradutor,
    vuetify,
    render: h => h(App),
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js